import { Injectable } from '@angular/core';
import { BaseWooCommerceV2ApiService } from './base-woo-commerce-v2-api.service';
import { map, Observable } from 'rxjs';
import { WooCommercePickupLocationDatetimeResponse } from '../../../interfaces/woo-commerce/api/shipping-datetime/shipping-datetime-api.interface';

@Injectable({ providedIn: 'root' })
export class WooCommerceShippingDatetimeApiService extends BaseWooCommerceV2ApiService {
  getShippingDatetime(
    locationId: string
  ): Observable<WooCommercePickupLocationDatetimeResponse> {
    return this.get('/delivery-dates', {
      params: { pickup_location_id: locationId, days_ahead: 14 }
    }).pipe(map((response: any) => this.mapDeliveryDatesResponse(response)));
  }

  getDeliveryDates(
    zoneShippingMethodId: number | string
  ): Observable<WooCommercePickupLocationDatetimeResponse> {
    return this.get('/delivery-dates', {
      params: { zone_shipping_method_id: zoneShippingMethodId, days_ahead: 14 }
    }).pipe(map((response: any) => this.mapDeliveryDatesResponse(response)));
  }

  private mapDeliveryDatesResponse(
    response: any
  ): WooCommercePickupLocationDatetimeResponse {
    const dates = response?.data || response || [];
    return {
      delivery_dates: dates
        .filter((item: any) => item?.is_available)
        .map((item: any) => ({
          date: item?.date
        }))
    } as WooCommercePickupLocationDatetimeResponse;
  }
}
